import { useState } from 'react';
import { ActivityIndicator, Alert, Image, Platform, ScrollView, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { login, register } from '../lib/api';

export default function AuthScreen({ onAuthenticated }) {
  const [mode, setMode] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const showMessage = (title, message) => {
    if (Platform.OS === 'web') window.alert(`${title}\n\n${message}`);
    else Alert.alert(title, message);
  };

  const submit = async () => {
    setLoading(true);
    try {
      const session = mode === 'login'
        ? await login({ email, password })
        : await register({ name, email, password });
      onAuthenticated(session.user);
    } catch (err) {
      showMessage('Authentication failed', err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView className="flex-1 bg-slate-950" contentContainerStyle={{ flexGrow: 1, padding: 20 }}>
      <View className="flex-1 justify-center">
        <View className="items-center">
          <Image source={require('../assets/logo.png')} className="h-24 w-24 rounded-3xl" resizeMode="contain" />
          <Text className="mt-5 text-sm font-semibold uppercase text-cyan-200">AurionXtrack</Text>
          <Text className="mt-2 text-center text-3xl font-black text-white">Know where every day leaves you.</Text>
          <Text className="mt-3 text-center text-base text-slate-300">
            Track income, expenses, brought-forward cash, loss days, and the activities draining your budget.
          </Text>
        </View>

        <View className="mt-8 rounded-2xl bg-white p-5">
          <View className="mb-4 flex-row rounded-2xl bg-slate-100 p-1">
            {['login', 'register'].map((entry) => (
              <TouchableOpacity key={entry} className={`flex-1 rounded-xl px-4 py-3 ${mode === entry ? 'bg-slate-950' : ''}`} onPress={() => setMode(entry)}>
                <Text className={`text-center font-bold capitalize ${mode === entry ? 'text-white' : 'text-slate-600'}`}>{entry}</Text>
              </TouchableOpacity>
            ))}
          </View>

          {mode === 'register' ? (
            <TextInput className="mb-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-950" placeholder="Name" placeholderTextColor="#94a3b8" value={name} onChangeText={setName} />
          ) : null}
          <TextInput className="mb-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-950" placeholder="Email" placeholderTextColor="#94a3b8" autoCapitalize="none" keyboardType="email-address" value={email} onChangeText={setEmail} />
          <TextInput className="mb-4 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-950" placeholder="Password" placeholderTextColor="#94a3b8" secureTextEntry value={password} onChangeText={setPassword} />

          <TouchableOpacity className="rounded-2xl bg-cyan-700 px-4 py-3" disabled={loading} onPress={submit}>
            {loading ? <ActivityIndicator color="#ffffff" /> : (
              <View className="flex-row items-center justify-center">
                <MaterialIcons name={mode === 'login' ? 'login' : 'person-add'} size={20} color="#ffffff" />
                <Text className="ml-2 text-center font-bold text-white">{mode === 'login' ? 'Log in' : 'Create account'}</Text>
              </View>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </ScrollView>
  );
}
